import { useEffect, useState } from 'react';

export function useLocalStorageMeta(key: string, current?: string | null) {
  const [value, setValue] = useState<string | undefined | null>();

  useEffect(() => {
    if (!value && !current) {
      const newValue = localStorage.getItem(key);
      setValue(newValue);
    }

    if (current && value != current) {
      localStorage.setItem(key, current);
      setValue(current);
    }
  }, [key, current]);

  return { value };
}

export function useLocalStorageMetaJSON<T>(key: string, current?: T | null) {
  const [value, setValue] = useState<T | undefined | null>();

  useEffect(() => {
    if (!value && !current) {
      const newValue = localStorage.getItem(key);
      setValue(newValue ? JSON.parse(newValue) : null);
    }

    if (current && value != current) {
      localStorage.setItem(key, JSON.stringify(current));
      setValue(current);
    }
  }, [key, current]);

  return { value };
}
